import React, { useEffect } from 'react'
import './AddPhoneNumberStyle.css'
import useAddPhoneNumber from './useAddPhoneNumber'
import PortNumberModal from '../PortNumber/PortNumberModal.component'
import { Breadcrumbs, Button } from '@enamelai/design-system'

const AddPhoneNumber = (): React.ReactElement | null => {
  const hooks = useAddPhoneNumber()

  useEffect(() => {
    hooks.setHeaderButtons(null)
    hooks.setHeaderTitle(
      <Breadcrumbs
        items={[
          { label: 'Phone management', onClick: hooks.cancelToList },
          { label: 'Port number' },
        ]}
        showBackIcon
        onBackClick={hooks.cancelToList}
      />,
    )
    return () => {
      hooks.setHeaderTitle(null)
      hooks.setHeaderButtons(null)
    }
  }, [hooks.setHeaderTitle, hooks.setHeaderButtons, hooks.cancelToList])

  return (
    <>
      <div className="scp-pm-add-number">
        <span className="scp-pm-label">Phone number</span>
        <div className="scp-pm-button-group">
          <Button
            size="sm"
            variant="secondary"
            onClick={() => hooks.setMethod('port')}
          >
            Port number
          </Button>
          <Button
            size="sm"
            variant="primary"
            onClick={() => hooks.setMethod('purchase')}
          >
            Purchase number
          </Button>
        </div>
        {hooks.method === 'purchase' && (
          <p className="scp-pm-muted">
            Purchasing numbers from Twilio will be available in a future
            release.
          </p>
        )}
      </div>
      <PortNumberModal
        show={hooks.method === 'port'}
        onHide={() => hooks.setMethod(null)}
      />
    </>
  )
}

export default AddPhoneNumber
